import React, { useEffect, useState } from "react";

import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { getRecords } from "../../../actions/matching";
import { connect } from "react-redux";
import { MY_PROFILE, SITE_URL } from "../../../actions/types";

const SingleUserMatchList = ({ match, getRecords }) => {
  const [matchData, setMatchData] = useState([]);
  const [apiHit, setApiHit] = useState(false);
  useEffect(() => {
    getRecords(match.params.id).then((res) => {
      console.log(res);
      if (res.success) {
        setMatchData(res.data);
      }
      setApiHit(true);
      // if(res.success){
      //   setChannelId(res.data[0]._id);
      //   if(res.data.length>0){
      //       var msgdata = res.data[0];
      //       console.log(msgdata);
      //       for(var user=0;user<msgdata.users_data.length;user++){
      //           console.log(msgdata.users_data[user]);
      //           if(msgdata.users_data[user]._id != myId){
      //           setChatName(msgdata.users_data[user].firstname);
      //           console.log(msgdata.users_data[user]);

      //           }
      //       }
      //   }
      //     setChannelList(<div className="str-chat str-chat-channel-list messaging light  ">
      //     <div className="str-chat__channel-list-messenger">
      //       <div className="str-chat__channel-list-messenger__main">
      //         {res.data.length>0 && res.data.map((msg,index) => (
      //             msg.users_data.length>0 && msg.users_data.map((user,i) => (
      //               user._id != myId && (
      //           <button key={index+i} onClick={() => {setChannelId(msg._id);setChatName(user.firstname)}} className="str-chat__channel-preview-messenger  str-chat__channel-preview-messenger--active" data-testid="channel-preview-button">
      //           <div className="str-chat__channel-preview-messenger--left">
      //               <img src={MY_PROFILE+user.profile_image[0]} />
      //           </div>
      //           <div className="str-chat__channel-preview-messenger--right">

      //                   <div className="str-chat__channel-preview-messenger--name"><span>{user.firstname}</span></div>

      //           </div>
      //         </button>
      //         )

      //         ))
      //         ))}

      //       </div>
      //     </div>
      //   </div>);
      //  //setChannelId(res.data[0]._id);
      //   const initChat = async () => {
      //       const client = StreamChat.getInstance('qjq3rf8g52gt');

      //       await client.connectUser(
      //           {
      //           id: myId
      //           },
      //           res.chatToken,
      //       );
      //       console.log(client.activeChannels);

      //       setChatClient(client);
      //       };
      //       initChat();

      // }
    });
  }, []);

  return (
    <>
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        {/* End of Sidebar */}
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/* Main Content */}
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Matches Of Selected User
                  </h6>
                </div>
                <div className="card-body">
                  <style
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n.match-data{\ntext-align:center\n}\n.match-data img {\n    height: 100px;\n    width: 100px;\n    border: 2px solid #355ccc;\n    border-radius: 50%;\n}\ni.fas.fa-comment-dots {\n    font-size: 70px;\n    color: #4d72df;\n}\n.message:hover i {\n\t-webkit-transform: rotate(15deg) scale(1.2);\n\ttransform: rotate(15deg) scale(1.2);\n\t-webkit-transition: .3s ease-in-out;\n\ttransition: .3s ease-in-out;\n    cursor: pointer;\n}\n.message i {\n\t-webkit-transform: rotate(0) scale(1);\n\ttransform: rotate(0) scale(1);\n    transition: .3s ease-in-out;\n}\n",
                    }}
                  />
                  <style
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n.col-md-4.message p {\n    color: #4d72df;\n}\n.col-md-4.message {\n    cursor: pointer;\n}\n",
                    }}
                  />
                  <style
                    dangerouslySetInnerHTML={{
                      __html:
                        "\n.hoverable i.fas.fa-flag {\n    top: 0;\n    position: absolute;\n    font-size: 15px;\n    border-radius: 50%;\n    border: 2px solid #4a70dc;\n    padding: 7px;\n    background: white;\n    color: red;\n}\n",
                    }}
                  />
                  {matchData.length == 0 && apiHit == true ? (
                    <div className="alert alert-danger">
                      This user has no matches or chats yet!{" "}
                    </div>
                  ) : (
                    ""
                  )}
                  <table
                    className="table table-bordered"
                    style={{ color: "black" }}
                    id="dataTable"
                    width="100%"
                    cellSpacing={0}
                  >
                    <tbody>
                      {matchData && matchData.length > 0
                        ? matchData.map((match, i) => (
                            <tr>
                              <th>
                                {console.log(match)}
                                <div className="row " key={i}>
                                  <div className="col-md-3"></div>
                                  <div className="col-md-6 match-data">
                                    <p>Match ID</p>
                                    <p>{match._id}</p>
                                    <div className="row hoverable align-items-center">
                                      {match.users_data.map((user, index) => (
                                        <>
                                          <div className="col-md-4">
                                            <img
                                              src={
                                                MY_PROFILE +
                                                "/" +
                                                user?.profile_image[0]
                                              }
                                              onError={(e) => {
                                                e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                                                e.target.src =
                                                  "/img/noImage.png"; // Fallback image if loading fails
                                              }}
                                            />
                                            {user.flag == 1 && (
                                              <i
                                                className="fas fa-flag"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title={`${user.reason}`}
                                              />
                                            )}
                                            <p>{user.firstname}</p>
                                          </div>
                                          {index == 0 && (
                                            <div
                                              className="col-md-4 message"
                                              onClick={() =>
                                                (window.location = `${SITE_URL}/single-user-match-chat/${match._id}`)
                                              }
                                            >
                                              <i className="fas fa-comment-dots"></i>
                                              <p>Open Chat History</p>
                                            </div>
                                          )}
                                        </>
                                      ))}
                                    </div>
                                  </div>
                                  <div className="col-md-3"></div>
                                </div>
                              </th>
                            </tr>
                          ))
                        : ""}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </div>
          {/* End of Main Content */}
          {/* Footer */}
          <Footer />
          {/* End of Footer */}
        </div>
        {/* End of Content Wrapper */}
      </div>
      {/* End of Page Wrapper */}
      {/* Scroll to Top Button*/}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  alert: state.alert,
});
export default connect(mapStateToProps, {
  getRecords,
})(SingleUserMatchList);
